import { render, staticRenderFns } from "./BallDetector.vue?vue&type=template&id=1866fa54"
import script from "./BallDetector.vue?vue&type=script&lang=ts"
export * from "./BallDetector.vue?vue&type=script&lang=ts"
import style0 from "./BallDetector.vue?vue&type=style&index=0&id=1866fa54&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports